import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const materialDisassemblyUiNodeSpec: UiNodeSpec<'materialDisassembly'> = {
    cfg: () => ({
        kind: 'materialDisassembly',
        id: getUID(),
        controlValues: {
            reason: null,
        },
    }),
    controls: getNodeCfg => ({
        reason: {
            cfg: {
                kind: 'text',
                nullable: true,
                label: 'Reason',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.reason,
        },
    }),
    inputs: () => {
        return {
            // ...cfg.controlValues.materialsToDisassemble.reduce((acc, _, index) => {
            //     acc[`material_id${index}`] = new UiFlowNodeInput({
            //         control: new UiFlowNodeControl({
            //             nodeCfg: cfg,
            //             value: cfg.controlValues.materialsToDisassemble[index],
            //             cfg: {
            //                 kind: 'text',
            //             },
            //         }),
            //         socket: new UiFlowNodeSocket('string'),
            //         label: `Material ID ${index + 1}`,
            //         index,
            //     });
            //     return acc;
            // }, {} as ReturnType<UiNodeSpec<'materialAssembly'>['inputs']>), // TODO: reimplement with dynamic 
            trigger: { socket: 'event', label: 'Trigger' },
            material1Id: { socket: 'string', label: 'Material ID' },
            material2Id: { socket: 'string', label: 'Material ID' },
        };
    },
    requiredSockets: [ 'trigger', 'material1Id', 'material2Id' ],
    kindLabel: 'Material Disassembly',
    nodeCategory: 'argonautApi',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
    }),
    validator: nodeCfg => {
        if (!nodeCfg.controlValues.reason) {
            return { reason: 'Reason is required' };
        } else {
            return true;
        }
    },
};
